export class InteractionsSummaryBasicModel {
  public allDrugsInteractionsCount: number;
  public allAlcoholFoodInteractionsCount: number;
  public allDiseaseInteractionsCount: number;
  public medicineInteractionsContent: string;
}